<template>
  <layout-scroll-content>
    <div class="row">
      <div class="col-xl-8 col-12 order-2 order-xl-1">
        <!-- FORM OF RFQ -->
        <form-rfq
          :disabled="!isAllowToEditRFQs"
          ref="FormRFQ"
          :data="data"
          :dataID="data.id"
          :model="formModel"
          @updateModelItem="handlerUpdateModelItem"
          @updateViewData="handlerUpdateViewDataRFQ"
          @change="(formData) => $emit('command', 'update-form-data', formData)"
        ></form-rfq>
        <!-- GRID OF RFQ1 -->
        <add-to-rfq-3
          disabled
          :moduleName="moduleName"
          :data="data"
          :isValid="true"
          :eventID="eventID"
          :showButton="false"
        ></add-to-rfq-3>
        <!-- LIST OF RFQ3 -->
        <list-rfq-3
          disabled
          :moduleName="moduleName"
          :data="data"
          :isValid="true"
          :eventID="eventID"
          :showButton="false"
        />
      </div>
      <!-- INFO -->
      <div class="col-xl-4 col-12 order-1 order-xl-2 vb-xl">
        <info-section-rfq :data="fullDataRFQ"></info-section-rfq >
        <info-section-parts
          :listRFQ1="listRFQ1"
          :mapListRFQ3="mapListRFQ3"
          :isAddToQuote="false"
          :isSendQuote="false"
        />
        <info-section-quotes
          :data="listRFQ3"
          :fieldList="fieldListInfoRFQ3"
        ></info-section-quotes>
        <info-section-po :data="fullDataRFQ"></info-section-po>
      </div>
      <!-- DIALOG -->
      <dialog-add-to-rfq3 :isLoading="isLoading" ref="dialog-add-to-rfq3"></dialog-add-to-rfq3>
    </div>
  </layout-scroll-content>
</template>

<script>
import FormWrapperAutoSave from '@/components/Form/FormWrapperAutoSave'
import { api } from '@/services/api'
export default {
  name: 'TabRFQ',
  mixins: [FormWrapperAutoSave],
  components: {
    'layout-scroll-content': () => import(/* webpackChunkName: 'Layouts' */ '@/components/Layouts/EditorPage/ScrollContent.vue'),
    'form-rfq': () => import(/* webpackChunkName: 'CustomerPoClose' */ './FormRFQ.vue'),
    'add-to-rfq-3': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/RFQAddToRFQ3/Index.vue'),
    'list-rfq-3': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/RFQListRFQ3/Index.vue'),
    'info-section-quotes': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/InfoSectionQuotes'),
    'info-section-po': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/InfoSectionPO'),
    'info-section-rfq': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/InfoSectionRFQ'),
    'info-section-parts': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/InfoSectionParts'),
    'dialog-add-to-rfq3': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/RFQDialogAddToRFQ3/Index')
  },
  props: {
    eventID: { type: String, required: true },
    moduleName: { type: String, required: true },
    hasCreateNew: { type: Boolean },
    data: { type: Object },
    formData: { type: Object },
    fullDataRFQ: { type: Object }
  },
  data () {
    return {
      isLoading: false,
      fieldListInfoRFQ3: [
        { title: this.L10n('chosen'), fieldName: 'chosen' },
        { title: this.L10n('part-number'), fieldName: 'partNumber' },
        { title: this.L10n('qty'), fieldName: 'qty' },
        { title: this.L10n('price'), fieldName: 'price' },
        { title: this.L10n('partSN'), fieldName: 'partSN' },
        { title: this.L10n('condition'), fieldName: 'conditionTitle' }
      ]
    }
  },
  computed: {
    isAllowToEditRFQs () {
      return this.permission(this.$store.getters.get('permissions'), 'isAllowToEditRFQs')
    },
    isAvailableToSave () {
      return this.isAllowToEditRFQs
    },
    mapListRFQ3 () {
      return this.$store.getters[`${this.moduleName}/mapListRFQ3`]
    },
    listRFQ1 () {
      return this.$store.state[this.moduleName].listRFQ1
    },
    listRFQ3 () {
      return this.$store.state[this.moduleName].listRFQ3
    }
  },
  methods: {
    formModel () {
      return {
        id: null,
        rfqid: '',
        customerCompanyID: null,
        customerCompanyDetailID: null,
        customerContactID: null,
        requestedDate: null,
        rfqTypeID: null,
        baxEmployeeID: this.$store.getters.get('currentUser').employeeID,
        po: '',
        poDate: null,
        pOisOpen: true,

        shipToCompanyID: null,
        shipToContactID: null,
        shipToCompanyDetailID: null,
        customerForwarderID: null,
        priorityID: null,
        orderRatingScoreID: null,
        paymentTermID: null,
        observation: ''
      }
    },
    // Handler of command from main editor
    controllerCommand (command) {
      switch (command) {
        case 'save':
          this.save()
          break
        default:
          this.setCommand(command)
          break
      }
    },
    // Send command to main editor
    setCommand (command) {
      this.$emit('command', command)
    },
    save () {
      this.$refs.FormRFQ.validate()
        .then(() => {
          let data = this.$refs['FormRFQ'].getData()
          let url = `RFQs/Patch/${data.id}`
          return api
            .patch(`${url}`, data)
            .then((response) => {
              this.requestSuccessHandler()
            })
            .catch(error => {
              this.requestErrorHandler(error)
            })
        })
    },
    getFormData () {
      return this.$refs.FormRFQ.getData()
    },
    handlerUpdateViewDataRFQ (value) {
      this.$store
        .commit(`${this.moduleName}/MERGE`, { key: 'dataViewRFQ', value })
    }
  }
}
</script>
